import api from '../utils/api';
import { LoginModel, ChangePasswordModel } from "./LoginModels";

export const login = (loginData: LoginModel) => {

    const loginRequestBody = new URLSearchParams();
    loginRequestBody.append('grant_type', 'password');
    loginRequestBody.append('username', loginData.email);
    loginRequestBody.append('password', loginData.password);
    loginRequestBody.append('scope', 'openid,profile,email,roles,api_access');

    return new Promise((resolve, reject) => {
        api.post('api/authorization/token', loginRequestBody)
            .then(res => {
                if (res.status === 200) {
                    return resolve(res.data);
                }
                reject(res);
            })
            .catch(reason => {
                reject(reason)
            });
    })
}

export const logout = () => {
    return new Promise((resolve, reject) => {
        resolve(true);
    })
}

export const changePassword = (changePasswordData: ChangePasswordModel): Promise<boolean> => {
    return new Promise((resolve, reject) => {
        api.post('api/accounts/password', changePasswordData)
            .then(res => {
                if (res.status === 200) {
                    return resolve(true);
                }
                resolve(false);
            })
            .catch(reason => reject(reason));
    });
}

export const resetPassword = (userName: string): Promise<boolean> => {
    return api.post("api/accounts/reset", { userName }).then(response => {
        if (response.status === 200) {
            return true;
        }
        return false;
    });
}


// WEBPACK FOOTER //
// ./src/login/auth.ts